import React, { useEffect, useState } from 'react'
import {
    Button,
    Col,
    Drawer,
    Form,
    Input,
    message,
    Row,
    Select,
    Space
} from 'antd';
import { post } from 'util/http';
import module from 'util/module';
import DictSelect from "component/DictSelect";
import SearchTree from 'component/SearchTree';

const { Option } = Select;
const { TextArea } = Input;

const Page = ({
    param,
    setParam,
    reload
}) => {


    const metaCode = "paifuProjectType"

    const [pageForm] = Form.useForm();

    const [meta, setMeta] = useState({
        attrs: []
    });


    useEffect(() => {
        post(module.app + '/meta/v1.0/get-by-code', { code: metaCode })
            .then(res => {
                console.log(res.data);
                setMeta(res.data);
            })
    }, [])
    useEffect(() => {
        if (param.visible) {
            if (param.id != '') {
                post(module.app + '/meta/v1.0/data/get', {
                    id: param.id,
                    metaCode: metaCode
                }).then(res => {
                    pageForm.setFieldsValue({
                        ...res.data
                    });
                })
            } else {
                pageForm.resetFields();
            }
        }


    }, [param])

    return (<Drawer title="创建集群"
        placement="right"
        width={660}
        maskClosable={false}
        onClose={() => {
            setParam({ ...param, visible: false })
        }}
        visible={param.visible}
        extra={
            <Space>
                <Button onClick={() => {
                    setParam({ ...param, visible: false })
                }}>取消</Button>
                <Button type="primary" onClick={() => {
                    const data = pageForm.getFieldsValue();
                    const url = module.app + '/meta/v1.0/data/save';
                    post(url, {
                        metaCode: metaCode,
                        datas: data
                    })
                        .then(res => {
                            setParam({ ...param, visible: false });
                            reload();
                            message.info("保存成功");
                        })
                }}>
                    确认
                </Button>
            </Space>
        }
    >
        <Form form={pageForm} layout="horizontal" hideRequiredMark
            labelCol={{
                style: { width: 80 }
            }}
            initialValues={{
                attrs: []
            }}
        >
            <Form.Item style={{ display: 'none' }}
                name="id">
                <Input type="hidden"
                />
            </Form.Item>
            {meta.attrs.map((item) => {
                return item.isSystem == 2 &&
                    (
                        <Form.Item
                            name={item.attrCode}
                            label={item.attrName}
                            key={item.attrCode}
                        // rules={[{ required: true, message: '请输入名称' }]}
                        >
                            {item.attrCode == 'parentCode' ? (
                                <SearchTree
                                    url={module.app + "/meta/v1.0/data/tree"}
                                    param={{ metaCode: metaCode, showRoot: true }}
                                    valueCode='code'
                                />
                            ) : (
                                <Input
                                    style={{ width: '100%' }}
                                // placeholder="请输入名称"
                                />
                            )}

                        </Form.Item>
                    )
            })}
        </Form>
    </Drawer>)
}

export default Page;